var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.getClassedBasedOnDirection('arrow-button'), ..._vm.buttonOptionalClasses]},[_c('button',{staticClass:"owc-subnavigation__arrow-button wb-round-button wb-round-button--medium",attrs:{"aria-label":_vm.buttonLabel}},[_c('wb-icon',{class:['wb-round-button__icon', ..._vm.iconOptionalClasses],attrs:{"name":_vm.iconName,"aria-hidden":"true"}})],1),(_vm.hasBackground)?_c('div',{class:[
      'owc-subnavigation__background',
      _vm.getClassedBasedOnDirection('background'),
      ..._vm.backgroundOptionalClasses,
    ]}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }